export default "__VITE_ASSET__CHX0dkAf__";